
import withStringFormValue from "./withStringFormValue";

const PasswordInput = props => {
  const { onChange, value, passthroughProps } = props;

  return (
    <input
      className="form-control"
      type="password"
      onChange={onChange}
      value={value || ""}
      {...passthroughProps}
    />
  );
};

export default withStringFormValue(PasswordInput);
